module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/401.9a600bd8.png";